"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralsRoutes = void 0;
const route_1 = require("../route");
class ReferralsRoutes extends route_1.Route {
    constructor() {
        super('referrals');
    }
    getCode() {
        return this.get('/code');
    }
    getReferrerFromCode(code) {
        return this.get(`/referrer/${code}`);
    }
    getList() {
        return this.get('/list');
    }
    getStatus() {
        return this.get('/status');
    }
    redeemInviteCode(code) {
        return this.post('/redeem', { code });
    }
    getAmounts() {
        return this.get('/amounts');
    }
    getTextContents() {
        return this.get('/texts');
    }
}
exports.ReferralsRoutes = ReferralsRoutes;
//# sourceMappingURL=referrals.js.map